import {
  sanitizeInputs,
  allIdentityVerificationFields,
  allEmploymentDetailsFields,
  personalInformationFields,
  personalAccountDetailsFields,
  allContactFields,
  employerInformationFields,
  trustDetailsFields,
  additionalDetailsFields,
  nonRequiredContingentFields
} from './formFieldLists'

const moment = require('moment')

const formatDate = (date) => {
  if (!date) {
    return null
  }

  return moment(date).format('YYYY-MM-DD')
}

const removedMaskedFields = (inputs, field) => {
  if (inputs[field] && inputs[field].includes('*')) {
    delete inputs[field]
  }

  return inputs
}

export const mapContactValues = (inputs) => {
  const {
    birthdate,
    trustName,
    dateOfTrust,
    dateOfDeath,
    organizationName,
    ssn,
    identificationExpirationDate,
    identificationIssueDate
  } = inputs

  if (ssn && ssn.length <= 4) {
    delete inputs.ssn
  }

  if (trustName) {
    inputs.lastName = trustName
  }

  if (organizationName) {
    inputs.lastName = organizationName
  }

  inputs.birthdate = formatDate(birthdate)
  inputs.dateOfTrust = formatDate(dateOfTrust)
  inputs.dateOfDeath = formatDate(dateOfDeath)
  inputs.identificationIssueDate = formatDate(identificationIssueDate)
  inputs.identificationExpirationDate = formatDate(identificationExpirationDate)

  // if identificationNumber or taxIdentificationNumber contains *,
  // it means that the user didnt enter any id to be updated (since it is not the whole id number)
  const finalInputs = {
    ...inputs,
    ...removedMaskedFields(inputs, 'identificationNumber'),
    ...removedMaskedFields(inputs, 'taxIdentificationNumber')
  }

  const sanitizedInputs = sanitizeInputs(finalInputs, allContactFields)
  return sanitizedInputs
}

export const mapIdentityVerificationValues = (inputs) => {
  const idIssueDate = inputs.identificationIssueDate
  const idExpirationDate = inputs.identificationExpirationDate

  inputs.identificationIssueDate =  formatDate(idIssueDate)
  inputs.identificationExpirationDate = formatDate(idExpirationDate)


  const contingentFieldsToRemove = nonRequiredContingentFields(inputs)
  contingentFieldsToRemove.forEach((f) => {
    delete inputs[f]
  })

  // If ssn is  less than 4 digits, she didnt enter any ssn to be updated
  if (inputs.ssn && inputs.ssn.length <= 4) {
    delete inputs.ssn
  }

  // if identificationNumber contains *,
  // it means that the user didnt enter any id to be updated (since it is not the whole id number)
  const finalInputs = removedMaskedFields(inputs, 'identificationNumber')

  const sanitizedInputs = sanitizeInputs(finalInputs, allIdentityVerificationFields)
  return sanitizedInputs
}

export const mapEmploymentDetailsValues = (inputs) => {
  const contingentFieldsToRemove = nonRequiredContingentFields(inputs)
  contingentFieldsToRemove.forEach((f) => {
    delete inputs[f]
  })

  const sanitizedInputs = sanitizeInputs(inputs, allEmploymentDetailsFields)
  return sanitizedInputs
}


const mapAddress = (inputs) => {
  const {
    billingStreet,
    billingCity,
    billingPostalCode,
    billingState,
    billingCountry
  } = inputs

  return {
    personMailingStreet: billingStreet,
    personMailingCity: billingCity,
    personMailingPostalCode: billingPostalCode,
    personMailingState: billingState,
    personMailingCountry: billingCountry
  }
}

export const mapPersonalInformationValues = (inputs) => {
  const { personBirthdate, mailingSameAsHomeAddress } = inputs
  let mailingAddress = {}

  if (mailingSameAsHomeAddress) {
    mailingAddress = mapAddress(inputs)
  }

  inputs.personBirthdate = formatDate(personBirthdate)
  const sanitizedInputs = sanitizeInputs(inputs, personalInformationFields)

  return {
    ...sanitizedInputs,
    ...mailingAddress
  }
}

export const mapAccountDetailsValues = (inputs) => {
  const {
    paperlessDelivery,
    deceasedDod,
    deceasedDob,
    donorDateOfBirth,
    minorDateOfBirth,
  } = inputs
  inputs.paperlessDelivery = paperlessDelivery === 'Yes'

  inputs.deceasedDod = formatDate(deceasedDod)
  inputs.deceasedDob = formatDate(deceasedDob)
  inputs.donorDateOfBirth = formatDate(donorDateOfBirth)
  inputs.minorDateOfBirth = formatDate(minorDateOfBirth)

  const sanitizedInputs = sanitizeInputs(inputs, personalAccountDetailsFields)
  return sanitizedInputs
}

export const mapEmployerInformationFields = (inputs) => {
  const sanitizedInputs = sanitizeInputs(inputs, employerInformationFields)
  return sanitizedInputs
}

export const mapAdditionalDetailsFields = (inputs) => {
  const {
    sepAllowSeparateDeferral,
    sepCatchUpContributionsPermitted,
    simpleCatchUpContributionsPermitted,
  } = inputs

  inputs.sepAllowSeparateDeferral = sepAllowSeparateDeferral === 'Yes'
  inputs.sepCatchUpContributionsPermitted = sepCatchUpContributionsPermitted === 'Yes'
  inputs.simpleCatchUpContributionsPermitted = simpleCatchUpContributionsPermitted === 'Yes'

  const sanitizedInputs = sanitizeInputs(inputs, additionalDetailsFields)
  return sanitizedInputs
}

export const mapTrustDetailsValues = (inputs) => {
  const { paperlessDelivery, dateOfTrust } = inputs

  inputs.paperlessDelivery = paperlessDelivery === 'Yes'
  inputs.dateOfTrust = formatDate(dateOfTrust)

  // if taxIdentificationNumber contains *,
  // it means that the user didnt enter any id to be updated (since it is not the whole id number)
  const finalInputs = removedMaskedFields(inputs, 'taxIdentificationNumber')

  const sanitizedInputs = sanitizeInputs(finalInputs, trustDetailsFields)
  return sanitizedInputs
}



// WEBPACK FOOTER //
// ./src/utils/formDataMapping.js